<ng-container>
  <div class="ap-mb-spacing-4">
    <gstar-combobox
      [label]="question.label"
      [options]="options"
      keyProp="label"
      valueProp="value"
      [value]="value"
      ngDefaultControl
      [disabled]="question.disabled"
      [width]="150"
      (selectItem)="update($event)" />
  </div>
</ng-container>
